// Registration events — "Time" and Event ID columns must match Google Sheets / Apps Script.

export const DEFAULT_REGISTRATION_EVENT_KEY = 'california-jul-18-2026';



// Mason — must match the TimeSlots sheet "Time" column exactly.

const MASON_SHEET_TIME_WINDOWS = [

  '1:15 PM - 1:45 PM',

  '1:30 PM - 2:00 PM',

  '2:15 PM - 2:45 PM',

  '2:30 PM - 3:00 PM',

  '3:15 PM - 3:45 PM',
  
  '3:30 PM - 4:00 PM'

];



const MASON_SPOTS_PER_SLOT = 3;

const MASON_PARKLAKE_LOCATION =
  '';

const MASON_HUNTERS_GREEN_LOCATION =
  "6398 Hunter's Green Dr, Mason, OH 45040";

export const MASON_LESSON_TIMES =
  '1:15 PM - 1:45 PM, 1:30 PM - 2:00 PM, 2:15 PM - 2:45 PM, 2:30 PM - 3:00 PM, 3:15 PM - 3:45 PM & 3:30 PM - 4:00 PM';

const MASON_DESCRIPTION_INTRO =
  'Swim With a Splash is pleased to offer free private swim lessons in Mason, Ohio, led by Manta Rays swimmers as part of our effort to promote accessible, high-quality aquatic instruction and meaningful community engagement through youth athletics.';

const MASON_GROUP_LOCATION_TEXT =
  `Jun. 13–14: ${MASON_PARKLAKE_LOCATION}; Jul. 18–19: ${MASON_HUNTERS_GREEN_LOCATION}`;

const MASON_DESCRIPTION_DETAILS = `Location: ${MASON_GROUP_LOCATION_TEXT}
Swim Lesson: 30 min Private Lesson
(Participation is limited to one lesson per swimmer per day.)
Cost: Free
Participants: All ages welcome`;

/** Full copy for Home/Events group view (includes all dates and times). */
const MASON_DESCRIPTION = `${MASON_DESCRIPTION_INTRO}

Dates: Jun. 13, Jun. 14, Jul. 18 & Jul. 19, 2026
Time: ${MASON_LESSON_TIMES}
${MASON_DESCRIPTION_DETAILS}`;

/** Single-date registration pages — details with that day's location. */
export function getMasonRegistrationDescription(location) {
  return `Location: ${location}
Swim Lesson: 30 min Private Lesson
(Participation is limited to one lesson per swimmer per day.)
Cost: Free
Participants: All ages welcome`;
}



function buildMasonSlotsForSheetDay(dayLabel) {

  return MASON_SHEET_TIME_WINDOWS.map((time) => ({

    id: time,

    time,

    day: dayLabel,

    max_spots: MASON_SPOTS_PER_SLOT,

    available_spots: MASON_SPOTS_PER_SLOT,

    status: 'Available',

    matchSheetLoose: true

  }));

}

const DALLAS_TIME_WINDOWS = ['7:15-7:45pm', '8:00-8:30pm'];

function buildDallasSlots(dayLabel, spotsFirst, spotsSecond) {

  const spots = [spotsFirst, spotsSecond];

  return DALLAS_TIME_WINDOWS.map((time, i) => ({

    id: time,

    time,

    day: dayLabel,

    max_spots: spots[i],

    available_spots: spots[i],

    status: 'Available',

    matchSheetLoose: true

  }));

}



export const DALLAS_LESSON_TIMES = '7:15-7:45 PM & 8:00-8:30 PM';

const DALLAS_LOCATION_TEXT =
  'Fretz Aquatic Center (14778 Hillcrest Rd, Dallas, TX 75254)';

const DALLAS_DESCRIPTION_INTRO =
  'In collaboration with Dallas Parks and Recreation, Swim With a Splash is pleased to offer private swim lessons as part of a broader effort to promote accessible, high-quality aquatic instruction and meaningful community engagement through youth athletics. Lessons will be led by competitive swimmers from top swimming clubs.';

const DALLAS_DESCRIPTION_DETAILS = `Location: ${DALLAS_LOCATION_TEXT}
Swim Lesson: 30 min Private Lesson
(Participation is limited to one lesson per swimmer per day.)
Cost: Free Lesson + $10 Pool Entrance Fee
Participants: Age 6-13 with Prior Swim Experience`;

/** Full copy for Home/Events group view (includes all dates and times). */
const DALLAS_DESCRIPTION = `${DALLAS_DESCRIPTION_INTRO}

Dates: Jun. 1, Jun. 16, Jun. 22, Jun. 29, Jul. 13 & Jul. 14, 2026
Time: ${DALLAS_LESSON_TIMES}
${DALLAS_DESCRIPTION_DETAILS}`;

/** Single-date registration pages — details only (no date/time/header copy). */
export const DALLAS_REGISTRATION_DESCRIPTION = DALLAS_DESCRIPTION_DETAILS;

const DALLAS_LOCATION = DALLAS_LOCATION_TEXT;

// California — Jul 18–19, 2026 (1:30–4:30, 30-min sessions, 4 spots each)

const CALIFORNIA_SHEET_TIME_WINDOWS = [
  '1:30 PM - 2:00 PM',
  '2:00 PM - 2:30 PM',
  '2:30 PM - 3:00 PM',
  '3:00 PM - 3:30 PM',
  '3:30 PM - 4:00 PM'
];

const CALIFORNIA_SPOTS_PER_SLOT = 4;

const CALIFORNIA_LOCATION =
  '12655 Stella Ln, San Diego, CA 92129';

export const CALIFORNIA_LESSON_TIMES =
  '1:30 PM - 2:00 PM, 2:00 PM - 2:30 PM, 2:30 PM - 3:00 PM, 3:00 PM - 3:30 PM, 3:30 PM - 4:00 PM';

const CALIFORNIA_DESCRIPTION_INTRO =
  'Swim With a Splash is pleased to offer free private swim lessons in San Diego, California, led by Pacific Swim swimmers as part of our effort to promote accessible, high-quality aquatic instruction and meaningful community engagement through youth athletics.';

const CALIFORNIA_DESCRIPTION_DETAILS = `Location: ${CALIFORNIA_LOCATION}
Swim Lesson: 30 min Private Lesson
Cost: Free
Participants: All ages welcome`;

const CALIFORNIA_DESCRIPTION = `${CALIFORNIA_DESCRIPTION_INTRO}

Dates: Jul. 18 & Jul. 19, 2026
Time: ${CALIFORNIA_LESSON_TIMES}
${CALIFORNIA_DESCRIPTION_DETAILS}`;

export const CALIFORNIA_REGISTRATION_DESCRIPTION = CALIFORNIA_DESCRIPTION_DETAILS;

function buildCaliforniaSlotsForSheetDay(dayLabel) {
  return CALIFORNIA_SHEET_TIME_WINDOWS.map((time) => ({
    id: time,
    time,
    day: dayLabel,
    max_spots: CALIFORNIA_SPOTS_PER_SLOT,
    available_spots: CALIFORNIA_SPOTS_PER_SLOT,
    status: 'Available',
    matchSheetLoose: true
  }));
}

export const REGISTRATION_EVENTS = {

  'mason-jun-13-2026': {

    sheetsEventId: 2,

    name: 'Mason Swim Lessons – Jun 13, 2026',

    date: 'Jun 13, 2026',

    weekday: 'Saturday',

    location: MASON_PARKLAKE_LOCATION,

    description: MASON_DESCRIPTION,

    age_groups: '',

    status: 'Registration Open',

    staticTimeSlots: buildMasonSlotsForSheetDay('Saturday')

  },

  'mason-jun-14-2026': {

    sheetsEventId: 3,

    name: 'Mason Swim Lessons – Jun 14, 2026',

    date: 'Jun 14, 2026',

    weekday: 'Sunday',

    location: MASON_PARKLAKE_LOCATION,

    description: MASON_DESCRIPTION,

    age_groups: '',

    status: 'Registration Open',

    staticTimeSlots: buildMasonSlotsForSheetDay('Sunday')

  },

  'mason-jul-18-2026': {

    sheetsEventId: 4,

    name: 'Mason Swim Lessons – July 18, 2026',

    date: 'July 18, 2026',

    weekday: 'Saturday',

    location: MASON_HUNTERS_GREEN_LOCATION,

    description: MASON_DESCRIPTION,

    age_groups: '',

    status: 'Registration Open',

    staticTimeSlots: buildMasonSlotsForSheetDay('Saturday')

  },

  'mason-jul-19-2026': {

    sheetsEventId: 5,

    name: 'Mason Swim Lessons – Jul 19, 2026',

    date: 'July 19, 2026',

    weekday: 'Sunday',

    location: MASON_HUNTERS_GREEN_LOCATION,

    description: MASON_DESCRIPTION,

    age_groups: '',

    status: 'Registration Open',

    staticTimeSlots: buildMasonSlotsForSheetDay('Sunday')

  },

  'dallas-jun-1-2026': {

    sheetsEventId: 6,

    name: 'Dallas Swim Lessons – Jun 1, 2026',

    date: 'Jun 1, 2026',

    weekday: 'Monday',

    location: DALLAS_LOCATION,

    description: DALLAS_DESCRIPTION,

    age_groups: '',

    status: 'Registration Open',

    staticTimeSlots: buildDallasSlots('Monday', 6, 6)

  },

  'dallas-jun-16-2026': {

    sheetsEventId: 7,

    name: 'Dallas Swim Lessons – Jun 16, 2026',

    date: 'Jun 16, 2026',

    weekday: 'Tuesday',

    location: DALLAS_LOCATION,

    description: DALLAS_DESCRIPTION,

    age_groups: '',

    status: 'Registration Open',

    staticTimeSlots: buildDallasSlots('Tuesday', 3, 3)

  },

  'dallas-jun-22-2026': {

    sheetsEventId: 8,

    name: 'Dallas Swim Lessons – Jun 22, 2026',

    date: 'Jun 22, 2026',

    weekday: 'Monday',

    location: DALLAS_LOCATION,

    description: DALLAS_DESCRIPTION,

    age_groups: '',

    status: 'Registration Open',

    staticTimeSlots: buildDallasSlots('Monday', 6, 6)

  },

  'dallas-jun-29-2026': {

    sheetsEventId: 9,

    name: 'Dallas Swim Lessons – Jun 29, 2026',

    date: 'Jun 29, 2026',

    weekday: 'Monday',

    location: DALLAS_LOCATION,

    description: DALLAS_DESCRIPTION,

    age_groups: '',

    status: 'Registration Open',

    staticTimeSlots: buildDallasSlots('Monday', 5, 5)

  },

  'dallas-jul-13-2026': {

    sheetsEventId: 11,

    name: 'Dallas Swim Lessons – Jul 13, 2026',

    date: 'Jul 13, 2026',

    weekday: 'Monday',

    location: DALLAS_LOCATION,

    description: DALLAS_DESCRIPTION,

    age_groups: '',

    status: 'Registration Open',

    staticTimeSlots: buildDallasSlots('Monday', 6, 6)

  },
  'dallas-jul-14-2026': {

    sheetsEventId: 10,

    name: 'Dallas Swim Lessons – Jul 14, 2026',

    date: 'Jul 14, 2026',

    weekday: 'Tuesday',

    location: DALLAS_LOCATION,

    description: DALLAS_DESCRIPTION,

    age_groups: '',

    status: 'Registration Open',

    staticTimeSlots: buildDallasSlots('Tuesday', 6, 6)

  },

  'california-jul-18-2026': {

    sheetsEventId: 12,

    name: 'California Swim Lessons – July 18, 2026',

    date: 'July 18, 2026',

    weekday: 'Saturday',

    location: CALIFORNIA_LOCATION,

    description: CALIFORNIA_DESCRIPTION,

    age_groups: '',

    status: 'Registration Temporarily Closed',

    registrationDisabled: true,

    staticTimeSlots: buildCaliforniaSlotsForSheetDay('Saturday')

  },

  'california-jul-19-2026': {

    sheetsEventId: 13,

    name: 'California Swim Lessons – July 19, 2026',

    date: 'July 19, 2026',

    weekday: 'Sunday',

    location: CALIFORNIA_LOCATION,

    description: CALIFORNIA_DESCRIPTION,

    age_groups: '',

    status: 'Registration Temporarily Closed',

    registrationDisabled: true,

    staticTimeSlots: buildCaliforniaSlotsForSheetDay('Sunday')

  }

};



/** Display order on Home and Events pages */

export const UPCOMING_EVENT_KEYS = [

  'california-jul-18-2026',

  'california-jul-19-2026',

  'mason-jun-13-2026',

  'mason-jun-14-2026',

  'mason-jul-18-2026',

  'mason-jul-19-2026'

];

/** Options for feedback form — one per upcoming program */
export const FEEDBACK_EVENT_OPTIONS = [
  'Mason Swim Lessons 2026',
  'California Swim Lessons 2026',
  'Dallas Swim Lessons 2026'
];



/** Grouped upcoming events for Home and Events pages */

export const UPCOMING_EVENT_GROUPS = [
  {

    id: 'california-2026',

    title: 'California Swim Lessons',

    registrationKeys: [

      'california-jul-18-2026',

      'california-jul-19-2026'

    ]

  },
  {

    id: 'mason-2026',

    title: 'Mason OH Swim Lessons',

    registrationKeys: [

      'mason-jun-13-2026',

      'mason-jun-14-2026',

      'mason-jul-18-2026',

      'mason-jul-19-2026'

    ]

  }

];



export function getUpcomingGroupSummary(registrationKeys) {

  const first = REGISTRATION_EVENTS[registrationKeys[0]];

  if (!first) return '';

  return ` ${first.location} ${first.description}`;

}



const LEGACY_SLUG_MAP = {

  'mason-jun-13': 'mason-jun-13-2026',

  'mason-jun-14': 'mason-jun-14-2026',

  'mason-jul-18': 'mason-jul-18-2026',

  'mason-jul-19': 'mason-jul-19-2026',

  'dallas-jun-1': 'dallas-jun-1-2026',

  'dallas-jun-13': 'dallas-jun-16-2026',

  'dallas-jun-16': 'dallas-jun-16-2026',

  'dallas-jun-22': 'dallas-jun-22-2026',

  'dallas-jun-29': 'dallas-jun-29-2026',

  'dallas-jul-11': 'dallas-jul-11-2026',

  'dallas-jul-13': 'dallas-jul-13-2026',

  'dallas-jul-14': 'dallas-jul-14-2026',

  'california-jul-18': 'california-jul-18-2026',

  'california-jul-19': 'california-jul-19-2026'

};



const NUMERIC_ID_MAP = {

  '2': 'mason-jun-13-2026',

  '3': 'mason-jun-14-2026',

  '4': 'mason-jul-18-2026',

  '5': 'mason-jul-19-2026',

  '6': 'dallas-jun-1-2026',

  '7': 'dallas-jun-16-2026',

  '8': 'dallas-jun-22-2026',

  '9': 'dallas-jun-29-2026',

  '10': 'dallas-jul-14-2026',

  '11': 'dallas-jul-13-2026',

  '12': 'california-jul-18-2026',

  '13': 'california-jul-19-2026'

};



/**

 * @param {string | undefined} routeParam from `/register/:eventId`

 * @returns {keyof typeof REGISTRATION_EVENTS}

 */

export function resolveRegistrationEventKey(routeParam) {

  if (!routeParam) return DEFAULT_REGISTRATION_EVENT_KEY;

  const p = String(routeParam).trim().toLowerCase();

  if (REGISTRATION_EVENTS[p]) return p;

  if (LEGACY_SLUG_MAP[p]) return LEGACY_SLUG_MAP[p];

  if (NUMERIC_ID_MAP[p]) return NUMERIC_ID_MAP[p];

  return DEFAULT_REGISTRATION_EVENT_KEY;

}


